export default __webpack_public_path__ + "static/media/3465.76a12211.png";